/* global angular, _ */
angular.module('ua5App')
    .directive('postsFilter', ['$state', '$rootScope', '$filter', 'PostFactory', function($state, $rootScope, $filter, PostFactory) {
        return {
            restrict: 'A',
            templateUrl: 'components/posts-filter/posts-filter.html',
            scope: {
                currentFilters: '='
            },
            link: function($scope, element, attrs) {
                var date;

                $scope.categoryFilters = [
                    {
                        name: 'All Categories',
                        value: ''
                    },
                    {
                        name: 'Events',
                        cmsName: 'Event',
                        value: 'event'
                    },
                    {
                        name: 'Announcements',
                        cmsName: 'Announcement',
                        value: 'announcement'
                    },
                    {
                        name: 'Stories',
                        cmsName: 'Story',
                        value: 'story'
                    },
                    {
                        name: 'News',
                        cmsName: 'News',
                        value: 'news'
                    },
                    {
                        name: 'Newsletter',
                        cmsName: 'Newsletter',
                        value: 'newsletter'
                    }
                ];

                $scope.programFilters = [
                    {
                        name: 'All Programs',
                        value: ''
                    }
                ];

                $scope.tagFilters = [];

                if ($scope.currentFilters.tag) {
                    var tagArr = $scope.currentFilters.tag.split(',');
                    for (var i = 0; i < tagArr.length; i++) {
                        $scope.tagFilters.push({
                            slug: tagArr[i],
                            name: tagArr[i].replace('-', ' ')
                        });
                    }
                }

                $scope.deleteTag = function(slug) {
                    $scope.tagFilters = _.without($scope.tagFilters, _.findWhere($scope.tagFilters, {slug: slug}));
                    $scope.currentFilters.tag = $scope.tagFilters.join();
                };

                $scope.isHome = $state.current.name === 'home';

                function getPrograms() {
                    PostFactory.programs().query().$promise.then(function(programs) {
                        for (var i = 0; i<programs.length; i++) {
                            programs[i].value = programs[i].slug;
                        }
                        $scope.programFilters = $scope.programFilters.concat(programs);
                    });
                }
                getPrograms();

                $scope.updateFilters = function() {
                    $rootScope.$broadcast('postFilterChange', $scope.currentFilters);
                };

                $scope.$watch('currentFilters', function() {
                    $rootScope.$broadcast('postFilterChange', $scope.currentFilters);
                }, true);

                $scope.$on('$stateChangeSuccess', function(e, toState) {
                    $scope.isHome = toState.name === 'home';
                });

                $scope.$on('postFilterUpdate', function(e, args) {
                    var newFilter;
                    if (args.name) {
                        newFilter = _.where($scope[args.type + 'Filters'], {cmsName: args.name});
                    } else if (args.value || args.value === '') {
                        newFilter = _.where($scope[args.type + 'Filters'], {value: args.value.toString()});
                    } else if (args.literal === true) {
                        $scope.currentFilters[args.type] = args.literalString;
                    }
                    if (newFilter && newFilter.length > 0) {
                        var filterString = _.pluck(newFilter, 'value').join();
                        $scope.currentFilters[args.type] = filterString;
                    }
                });

                date = new Date();
                $scope.currentWeek = $filter('date')(date, 'fullDate');
            }
        };
    }])
;
